// Icon - SVG paths-by-name, mirroring the prototype's Icon component
// (nymr_events_manager_5.html, line 253). One viewBox, currentColor stroke,
// pipe-separated path strings so we can hand-author them without nesting
// nodes. Adding a new icon = add a new entry to ICON_PATHS and add the name
// to IconName.
//
// Falls back to "box" if a caller passes an unknown name - matches the
// prototype's behaviour.

const ICON_PATHS = {
  home: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z|M9 22V12h6v10',
  calendar: 'M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z|M16 2v4|M8 2v4|M3 10h18',
  'list-tree': 'M21 12h-8|M21 6h-8|M21 18h-8|M3 6v4c0 1.1.9 2 2 2h3|M3 10v6c0 1.1.9 2 2 2h3',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2|M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z|M22 21v-2a4 4 0 0 0-3-3.87|M16 3.13a4 4 0 0 1 0 7.75',
  box: 'M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z|M3.27 6.96 12 12.01l8.73-5.05|M12 22.08V12',
  'bar-chart': 'M3 3v18h18|M18 17V9|M13 17V5|M8 17v-3',
  'shield-check': 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z|M9 12l2 2 4-4',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z|M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c.36.16.66.42.88.74.22.32.34.7.34 1.09 0 .39-.12.77-.34 1.09-.22.32-.52.58-.88.74',
  plus: 'M12 5v14|M5 12h14',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z|M21 21l-4.35-4.35',
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9|M10.3 21a1.94 1.94 0 0 0 3.4 0',
  'check-circle': 'M22 11.08V12a10 10 0 1 1-5.93-9.14|M22 4 12 14.01l-3-3',
  'alert-triangle': 'M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z|M12 9v4|M12 17h.01',
  download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4|M7 10l5 5 5-5|M12 15V3',
  upload: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4|M17 8l-5-5-5 5|M12 3v12',
  edit: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7|M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z',
  x: 'M18 6 6 18|M6 6l12 12',
  chevronRight: 'M9 18l6-6-6-6',
  chevronLeft: 'M15 18l-6-6 6-6',
  chevronDown: 'M6 9l6 6 6-6',
  clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z|M12 6v6l4 2',
  flag: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z|M4 22V15',
  info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z|M12 16v-4|M12 8h.01',
  coffee: 'M17 8h1a4 4 0 1 1 0 8h-1|M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z|M6 2v3|M10 2v3|M14 2v3',
  grid: 'M3 3h7v7H3z|M14 3h7v7h-7z|M14 14h7v7h-7z|M3 14h7v7H3z',
  list: 'M8 6h13|M8 12h13|M8 18h13|M3 6h.01|M3 12h.01|M3 18h.01',
  grip: 'M9 6h.01|M15 6h.01|M9 12h.01|M15 12h.01|M9 18h.01|M15 18h.01',
  filter: 'M22 3H2l8 9.46V19l4 2v-8.54z',
  // Train (v2 spec 15). Approximate train silhouette: rounded carriage
  // with two windows, two wheels, and connecting lines. Chosen rather
  // than a coupled-rod loco to stay simple at 13px.
  train: 'M8 3h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z|M9 7h6|M9 11h6|M9 17l-2 4|M15 17l2 4|M5 17h14',
  // Resources panel (Live View PR L1 / spec 23). Used by the
  // ResourcesPanel tab strip and the seeded auto-attach rows in
  // migration 048. Paths cribbed from Feather Icons (MIT).
  map:         'M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z|M8 2v16|M16 6v16',
  star:        'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
  file:        'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z|M14 2v6h6|M16 13H8|M16 17H8|M10 9H8',
  'book-open': 'M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z|M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z',
  'first-aid': 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z|M12 8v8|M8 12h8',
  // Activity (Live View PR L2). Used by the "Launch Live View" brass
  // button (prototype L1796 — Icon name="activity" size={17}). Feather
  // Icons MIT path.
  activity: 'M22 12h-4l-3 9L9 3l-3 9H2',
  // Live View header + modals (PR L3). Feather Icons MIT paths.
  'arrow-left':     'M19 12H5|M12 19l-7-7 7-7',
  eye:              'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z|M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  lock:             'M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2z|M7 11V7a5 5 0 0 1 10 0v4',
  'message-square': 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  // Siren — used on the red Raise Alarm button (prototype L2390) and
  // the AlarmModal's oxblood circle (prototype L2743). Approximate
  // siren silhouette: dome + body + light flares.
  siren:            'M7 12a5 5 0 0 1 10 0v6H7v-6z|M5 18h14|M12 2v3|M4.93 6.93l2.12 2.12|M19.07 6.93l-2.12 2.12',
  phone:            'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z',
  target:           'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z|M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z|M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  // Pound sterling — MERAC sales/income badge on the Events cards.
  // lucide-react "pound-sterling" (ISC). Curve + stem + base + crossbar.
  pound:            'M18 7c0-5.333-8-5.333-8 0|M10 7v14|M6 21h12|M6 13h10',
  // Ticket (Feature 4). Feather "ticket" (ISC): stub with dashed perforation.
  ticket:           'M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z|M13 5v2|M13 17v2|M13 11v2',
  // Utensils (Feature 3 catering). Feather "utensils"-ish fork + knife.
  utensils:         'M3 2v7c0 1.1.9 2 2 2h0a2 2 0 0 0 2-2V2|M5 2v20|M17 2v20|M17 12c2 0 4-2 4-6s-2-6-4-6z'
} as const

export type IconName = keyof typeof ICON_PATHS

interface Props {
  name: IconName
  size?: number
  strokeWidth?: number
  className?: string
  title?: string
}

export function Icon({ name, size = 16, strokeWidth = 2, className, title }: Props) {
  const d = ICON_PATHS[name] ?? ICON_PATHS.box
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title && <title>{title}</title>}
      {d.split('|').map((p, i) => <path key={i} d={p} />)}
    </svg>
  )
}
